export const FAILED_MESSAGE = 'An error occured while setting up your DialogFlow agent.'
export const RESOLVED_MESSAGE = 'Your DialogFlow agent is now connected to the chatbot.'
export const PENDING_MESSAGE = 'Setting up your DialogFlow agent. This may take up to 60 seconds.'
